module.exports = __webpack_public_path__ + "media/images/OTC_reminder-a845aa1bbfe81ef54cd9bdbe21415bef.jpg";